import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IndicatorGoalResponseDto } from '../dto/response/indicator-goal-response.dto';
import indicatorGoalService from '../services/indicator-goal.service';
import { IndicatorGoalSaveRequestDto } from '../dto/request/indicator-goal-save-request.dto';
// import { IndicatorGoalUpdateRequestDto } from '../dto/request/indicator-goal-update-request.dto';

const initialState = {
  status: 'idle',
  indicatorGoals: [] as IndicatorGoalResponseDto[] | null,
  filteredIndicatorGoals: [] as IndicatorGoalResponseDto[] | null,
  indicatorGoal: {} as IndicatorGoalResponseDto | null,
  error: null as string | null,
};

// export const fetchIndicatorGoalById = createAsyncThunk(
//   'indicatorGoals/fetchIndicatorGoalById',
//   async (id: string) => {
//     return await indicatorGoalService.fetchIndicatorGoalById(id);
//   }
// );

export const fetchIndicatorGoalsByIndicatorId = createAsyncThunk(
  'indicatorGoals/fetchIndicatorGoalsByIndicatorId',
  async (indicatorId: string) => {
    return await indicatorGoalService.fetchIndicatorGoalsByIndicatorId(
      indicatorId
    );
  }
);

export const fetchIndicatorGoalsByGoalId = createAsyncThunk(
  'indicatorGoals/fetchIndicatorGoalsByGoalId',
  async (goalId: string) => {
    return await indicatorGoalService.fetchIndicatorGoalsByGoalId(goalId);
  }
);

export const saveIndicatorGoal = createAsyncThunk(
  'indicatorGoals/saveIndicatorGoal',
  async (saveRequest: IndicatorGoalSaveRequestDto) => {
    return await indicatorGoalService.saveIndicatorGoal(saveRequest);
  }
);

// export const updateIndicatorGoal = createAsyncThunk(
//   'indicatorGoals/updateIndicatorGoal',
//   async (updateRequest: IndicatorGoalUpdateRequestDto) => {
//     return await indicatorGoalService.updateIndicatorGoal(updateRequest);
//   }
// );

export const deleteIndicatorGoal = createAsyncThunk(
  'indicatorGoals/deleteIndicatorGoal',
  async (id: string) => {
    return await indicatorGoalService.deleteIndicatorGoal(id);
  }
);

const indicatorGoalSlice = createSlice({
  name: 'indicatorGoalSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // .addCase(fetchIndicatorGoalById.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchIndicatorGoalById.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.indicatorGoal = action.payload;
      // })
      // .addCase(fetchIndicatorGoalById.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(fetchIndicatorGoalsByIndicatorId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchIndicatorGoalsByIndicatorId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.filteredIndicatorGoals = action.payload;
      })
      .addCase(fetchIndicatorGoalsByIndicatorId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(fetchIndicatorGoalsByGoalId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchIndicatorGoalsByGoalId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.filteredIndicatorGoals = action.payload;
      })
      .addCase(fetchIndicatorGoalsByGoalId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(saveIndicatorGoal.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveIndicatorGoal.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.indicatorGoals?.push(action.payload);
      })
      .addCase(saveIndicatorGoal.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      // .addCase(updateIndicatorGoal.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(updateIndicatorGoal.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   if (state.indicatorGoals) {
      //     const indicatorGoalIndex = state.indicatorGoals.findIndex(
      //       (indicatorGoal) => indicatorGoal.id === action.payload.id
      //     );
      //     if (indicatorGoalIndex !== -1) {
      //       state.indicatorGoals[indicatorGoalIndex] = action.payload;
      //     }
      //   }
      // })
      // .addCase(updateIndicatorGoal.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(deleteIndicatorGoal.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteIndicatorGoal.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteIndicatorGoal.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      });
  },
});

export default indicatorGoalSlice.reducer;
